import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

const EquipmentOptions = ({ equipment, updateEquipment, updateEquipmentOption }) => {
  return (
    <div className="mt-2">
      {equipment.multipleQuantity && (
        <Row className="mb-2">
          <Col>
            <Form.Label className="small">Quantité</Form.Label>
            <Form.Select
              size="sm"
              value={equipment.quantity || 1}
              onChange={(e) => updateEquipment(equipment.instanceId, 'quantity', e.target.value)}
            >
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
            </Form.Select>
          </Col>
        </Row>
      )}

      {equipment.options && equipment.options.length > 0 && (
        <Row className="mb-2">
          <Col>
            <Form.Label className="small">Option</Form.Label>
            <Form.Select
              size="sm"
              value={equipment.selectedOption?.id ?? ''}
              onChange={(e) => {
                const selected = equipment.options.find(opt => opt.id === parseInt(e.target.value));
                if (selected) {
                  updateEquipmentOption(equipment.instanceId, selected);
                }
              }}
            >
              <option value="">Sélectionnez une option</option>
              {equipment.options.map(option => (
                <option key={option.id} value={option.id}>
                  {option.name} ({option.watt}W)
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      )}

      {equipment.id !== 3 && !equipment.totalGiven && (
        <Row className="mb-2">
          <Col>
            <Form.Label className="small">Utilisation (heures/jour)</Form.Label>
            <Form.Select
              size="sm"
              value={equipment.usage || 1}
              onChange={(e) => updateEquipment(equipment.instanceId, 'usage', e.target.value)}
            >
              <option value="0.08">5 minutes</option>
              <option value="0.16">10 minutes</option>
              <option value="0.25">15 minutes</option>
              <option value="0.5">30 minutes</option>
              <option value="0.75">45 minutes</option>
              <option value="1">1 heure</option>
              <option value="2">2 heures</option>
              <option value="3">3 heures</option>
              <option value="4">4 heures</option>
              <option value="5">5 heures</option>
              <option value="6">6 heures</option>
              <option value="7">7 heures</option>
              <option value="8">8 heures</option>
              <option value="9">9 heures</option>
              <option value="10">10 heures</option>
              <option value="11">11 heures</option>
              <option value="12">12 heures</option>
              <option value="13">13 heures</option>
              <option value="14">14 heures</option>
              <option value="15">15 heures</option>
              <option value="16">16 heures</option>
              <option value="17">17 heures</option>
              <option value="18">18 heures</option>
              <option value="19">19 heures</option>
              <option value="20">20 heures</option>
              <option value="21">21 heures</option>
              <option value="22">22 heures</option>
              <option value="23">23 heures</option>
              <option value="24">24 heures</option>
            </Form.Select>
          </Col>
        </Row>
      )}

      {equipment.showWarning && (
        <div className="alert alert-warning py-2 small mt-2">
          <div className="d-flex">
            <span className="me-2">⚠️</span>
            <div>
              <strong>Appareils à résistance</strong>
              <br />
              Batterie au Lithium nécessaire
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EquipmentOptions;